/**
 *
 * jQuery addon makes sorted maps easy as pie.
 *
 * Copyright 2016, Martin Černý
 * All rights reserved.
 *
 * version 1.02
 *
 */

(function($){
	$.fn.sortedmap = function(options){

		/* Default settings */
		var defaults = $.extend({
			center: [0,0], // center of the map
			styles: null, // gmaps styles
			zoom: 10, // zoom
			markers: null, // list of markers
			categories: false, // list of categories
			categoriesContainer: '#map-categories',
			categoriesReset: '#catsReset',
			infoWindow: true,
			area: false, // Coords of highlighted area polygon
			areaStyles:{
				strokeColor: '#FF0000',
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: '#FF0000',
				fillOpacity: 0.25
			},
			transitLayer: false,
			pinAttributes: {
				size: new google.maps.Size(32,51),
				scaledSize: new google.maps.Size(32,51),
				origin: new google.maps.Point(0,0),
				anchor: new google.maps.Point(16,51)
			}
		},options);

		// this extends default settings with HTML5 "data-" attributes
		var settings = $.extend(true, {}, defaults, this.data());

		/**
		 * =================
		 * BASE VARS
		 * =================
		 */
		var ele = this,
			map = {},
			//clusterer,
			markersToDelete = [];

		/**
		 * ===============
		 * INIT
		 * ===============
		 */
		var init = function () {
			map.map = new google.maps.Map($(ele)[0], {
				zoom: settings.zoom,
				center: new google.maps.LatLng(settings.center[0], settings.center[1]),
				styles: settings.styles,
				//disableDefaultUI: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_CENTER
				},
				scaleControl: false,
				streetViewControl: false,
				mapTypeControl: false,
				scrollwheel: false
			});
			map.infoWindow = new google.maps.InfoWindow({
				pixelOffset: new google.maps.Size(0, 0)
			});
			fixRoboto();
			markersInit();
			transitLayerInit();
			highlightInit();
			categoriesInit();
			//clusterize(map.map,markersToDelete,settings.clusterOptions);
		};

		/** Project area highlight */
		var highlightInit = function(){
			if(settings.area){
				map.projectHighlight = new google.maps.Polygon({
					paths: settings.area,
					strokeColor: settings.areaStyles.strokeColor,
					strokeOpacity: settings.areaStyles.strokeOpacity,
					strokeWeight: settings.areaStyles.strokeWeight,
					fillColor: settings.areaStyles.fillColor,
					fillOpacity: settings.areaStyles.fillOpacity
				});
				map.projectHighlight.setMap(map.map); // Construct the polygon.
			}
		};
		/** /Project area highlight */

		/** Transit layer */
		var transitLayerInit = function(){
			if(settings.transitLayer){
				var transitLayer = new google.maps.TransitLayer();
				transitLayer.setMap(map.map);
			}
		};
		/** /Transit layer */

		/** Markers & info popups */
		var markersInit = function(){
			for (var i = 0; i < settings.markers.length; i++) {
				(function(i) {
					var pin = settings.pinAttributes;
                    if(typeof settings.markers[i].pinAttributes !== 'undefined')
                        pin = settings.markers[i].pinAttributes;
					pin.url = settings.markers[i].icon;

                    var marker = new google.maps.Marker({
						position: new google.maps.LatLng(settings.markers[i].lat, settings.markers[i].lng),
						map: map.map,
						icon: pin
					});

					markersToDelete.push(marker);

					google.maps.event.addListener(marker, 'mouseover', function() {
						infoWindowReset(map.map, map.infoWindow, settings.markers[i], marker);
					});
					
					google.maps.event.addListener(marker, 'mouseout', function() {
						map.infoWindow.close(); // Close the info window when hover ends
					});

					/*
					google.maps.event.addListener(marker, 'click', function() {
						if(settings.infoWindow){
							infoWindowReset(map.map, map.infoWindow, settings.markers[i], marker);
						}
					});
					*/
				})(i);
			}
		};
		/** /markers & info popups */

		/** Categories */
		var categoriesInit = function(){
			if(settings.categories && settings.categoriesContainer){

				var activeCats = [],
					cats = cleanCategories(settings.categories);

				/* Add categories control panel */
				$(settings.categoriesContainer).append('<div class="row"></div>');
				for (i = 0; i < cats.length; i++) {
					$('.row',settings.categoriesContainer).append('<div class="col-lg-2 col-md-3 col-xs-6"><div class="category__item selected" data-category="' + cats[i].name + '"><a class="category__link" href="#"><div class="category__image"><img src="' + cats[i].icon + '" width="44" height="39"></div><span class="category__title">' + cats[i].name + '</span></a></div></div>');
				}

				$(settings.categoriesReset).on('click',function(){
					activeCats = settings.categories;
					$('li',settings.categoriesContainer).addClass('selected');
					$('.selected',settings.categoriesContainer).each(function(){
						activeCats.push($(this).data('category'));
					});
					removeMarkers(markersToDelete);
					showSelectedMarkers(activeCats,settings.markers);
					//clusterer.clearMarkers();
					//clusterize(map.map,markersToDelete,settings.clusterOptions);
				});

				$('a', settings.categoriesContainer).on('click',function(e){
					e.preventDefault();
					$(this).parent().toggleClass('selected');
					activeCats = [];

					$('.selected',settings.categoriesContainer).each(function(){
						activeCats.push($(this).data('category'));
					});

					removeMarkers(markersToDelete);
					showSelectedMarkers(activeCats,settings.markers);
					//clusterer.clearMarkers();
					//clusterize(map.map,markersToDelete,settings.clusterOptions);
				});
			}

		};
		/** /Categories */

		/** sort categories by name */
		var compare = function(a,b) {
			if (a.name < b.name)
				return -1;
			if (a.name > b.name)
				return 1;
			return 0;
		};

		/** Removes duplicate categories */
		var cleanCategories = function(categories){
			categories.sort(compare);
			var result = [], prevValue;
			for (var i = 0; i < categories.length; i++ ) {
				if(categories[i].name != prevValue){
					result.push(categories[i]);
				}
				prevValue = categories[i].name;
			}
			//console.log(result);
			return result;
		};

		/** Shows markers from selected categories */
		var showSelectedMarkers = function(categories,markers){
			var showMarker = false;
			for (var i = 0; i < markers.length; i++) {
				for (var ii = 0; ii < categories.length; ii++){
					if(String(markers[i]['cat']).indexOf(String(categories[ii])) > -1){
						showMarker = true;
					}
				}
				if(showMarker){
					(function(i) {
						var pin = settings.pinAttributes;
                        if(typeof settings.markers[i].pinAttributes !== 'undefined')
                            pin = settings.markers[i].pinAttributes;
						pin.url = markers[i].icon;

						var marker = new google.maps.Marker({
							position: new google.maps.LatLng(markers[i].lat,markers[i].lng),
							map: map.map,
							icon: pin
						});
						markersToDelete.push(marker);
						google.maps.event.addListener(marker, 'click', function() {
							if(map.infoWindow){
								infoWindowReset(map.map,map.infoWindow,markers[i], marker)
							}
						});
					})(i);
				}
				showMarker = false;
			}
		};

		/** Infowindow reset */
		var infoWindowReset = function(map,info,marker,markerItem){
			info.close();
			info.setContent('<div class="pin-info">'+marker.text+'</div>');
			info.open(map,markerItem);
		};

		/** Remove markers */
		var removeMarkers = function(markers) {
			for (var i = 0; i < markers.length; i++ ) {
				markers[i].setMap(null);
			}
			markers.length = 0;
		};

		/** Roboto font fix */
		var fixRoboto = function(){
			if(settings.fixRoboto = true){
				var head = document.getElementsByTagName('head')[0];
				var insertBefore = head.insertBefore;
				head.insertBefore = function (newElement, referenceElement) {
					if (newElement.href && (newElement.href.indexOf('http://fonts.googleapis.com/css?family=Roboto') === 0 || newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0)) {
						//console.info('Prevented Roboto from loading!');
						return;
					}
					insertBefore.call(head, newElement, referenceElement);
				};
			}
		};
		/** /Roboto font fix */

		/** Fire it! */
		google.maps.event.addDomListener(window, 'load', init());

		/** And finally return the object for chaining */
		return ele;
	};
}(jQuery));
